import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {EntityDescriptionSectionDomainModel} from "./entity-description.section.domain-model";
import type {EntityDescriptionElementDomainModel} from "../element/entity-description.element.domain-model";
import {EntityDescriptionElementViewModel} from "../element/entity-description.element.view-model";

export class EntityDescriptionSectionViewModel extends BaseViewModel {
  domainModel: EntityDescriptionSectionDomainModel;

  constructor(model: EntityDescriptionSectionDomainModel) {
    super(model);

    this.elements = model.elements?.map((element: EntityDescriptionElementDomainModel) => new EntityDescriptionElementViewModel(element));
  }

  getElementValue(filter) {
    const element = this.elements?.find(element => element.name.includes(filter));

    return element?.value
  }
}
